export default __webpack_public_path__ + "static/introductionImg-26e647c00807ae09cb97f04252b0c81f.svg";